/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharehistorytitle2Inputs */

const en_sharehistorytitle2 = /** @type {(inputs: Sharehistorytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest`)
};

const de_sharehistorytitle2 = /** @type {(inputs: Sharehistorytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt`)
};

/**
* | output |
* | --- |
* | "Latest" |
*
* @param {Sharehistorytitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharehistorytitle2 = /** @type {((inputs?: Sharehistorytitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharehistorytitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharehistorytitle2(inputs)
	return de_sharehistorytitle2(inputs)
});
export { sharehistorytitle2 as "shareHistoryTitle" }